module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasSale(_vm.item)) ? _c('div', {
    staticClass: "meta discount-wrapper"
  }, [_c('div', {
    staticClass: "ui labels"
  }, [_c('a', {
    staticClass: "ui bright-yellow label"
  }, [_vm._v("Akcija! " + _vm._s(_vm.getDiscountPercentage(_vm.item)) + "%")])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-814028e0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Discount.vue
// module id = 362
// module chunks = 1